import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import useEnrollmentQuoteUrlParams from 'global/hooks/useEnrollmentQuoteUrlParams';
import OverrideRatesProposalPlans from 'components/proposal-override-rates';
import ProposalOverrideRatesPageStore, {
  ProposalOverrideRatesPageStoreContext,
  useProposalOverrideRatesPageStore,
} from 'store/modules/override-rates/proposal-override-rates/pageStore';
import { bpHistory } from 'global/bpHistory';
import { OverrideRatesRedirectParams } from 'store/modules/override-rates/proposal-override-rates/delegates/cartItemDelegate';

const PageContent: React.FC = observer(() => {
  const { getInitialData, returnBack, isLoading } = useProposalOverrideRatesPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <NoSidebarPageLayout
      contentWidth="standard"
      isInitialLoading={isLoading}
      pageHeader={{
        title: 'Override Rates',
        subtitle: 'Choose the product and the specific version where you want to override or adjust the final rates',
        subtitleMaxWidth: '55%',
        onBackButtonClick: returnBack,
      }}
      pageFooter={{
        onBack: returnBack,
      }}
    >
      <OverrideRatesProposalPlans />
    </NoSidebarPageLayout>
  );
});

const ProposalOverrideRatesPage: React.FC = () => {
  const { periodId, groupId, cartId } = useEnrollmentQuoteUrlParams();

  const onOverrideRates = (params: OverrideRatesRedirectParams): void => {
    bpHistory.push(
      `/override-quoted-rates/${groupId}/${periodId}/${cartId}/${encodeURIComponent(params.portfolioId)}/${
        params.productLineId
      }/${params.bcIndex}`,
    );
  };

  const onReturnBack = (): void => {
    bpHistory.push(`/proposal-v2/${periodId}?groupId=${groupId}&cartId=${cartId}`);
  };

  const pageStore = useMemo(
    () =>
      new ProposalOverrideRatesPageStore(
        { enrollmentPeriodId: periodId, groupId, cartId },
        {
          onReturnBack,
          onOverrideRates,
        },
      ),
    [],
  );

  return (
    <ProposalOverrideRatesPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </ProposalOverrideRatesPageStoreContext.Provider>
  );
};

export default ProposalOverrideRatesPage;
